export function isObjectEmpty(obj: Record<string, unknown>): boolean {
    return Object.keys(obj).length === 0;
}

export function isObject(item: any): boolean {
    return item && typeof item === 'object' && !Array.isArray(item) && item !== null;
}

// Shallow equality fallback (can be replaced with deep compare lib if needed)
export function propsEqualityFn(prev: unknown, next: unknown): boolean {
    return prev === next;
}
